import styled from 'styled-components';

import type { TooltipAnchorProps } from './RefactoredTooltip';

import { COLOR } from '../../theme';

export const TooltipPopoverStyles = styled.div`
  z-index: 20;
  max-width: 350px;
  background-color: ${COLOR.DARK_GRAY_6};
  color: ${(props) => props.theme.colors.common.white};
  padding: 4px 14px 8px;
  line-height: 18px;
  border-radius: 4px;
`;

export const TooltipAnchorStyles = styled.div<TooltipAnchorProps>`
  ${(props) => props.fitContent && 'width: fit-content'}
`;
